import Yup from 'utils/validation/yup-extensions';

/**
 * Form property keys.
 */
export const FORM_KEYS = {
	ORGANIZATION_NAME: 'ORGANIZATION_NAME',
	ORGANIZATION_ID: 'ORGANIZATION_ID',
};

/**
 * Default Formik form initial value object.
 * @type {object}
 */
export const FORM_INITIAL_VALUES = Object.keys(FORM_KEYS).reduce((acc, key) => {
	acc[FORM_KEYS[key]] = '';
	return acc;
}, {});

export const VALIDATION_MESSAGE = 'Field is required.';

/**
 * Default Formik form Yup validation schema logic.
 * @type {object}
 */
export const FORM_VALIDATION_SCHEMA_OBJECT = {
	[FORM_KEYS.ORGANIZATION_NAME]: Yup.string().required(VALIDATION_MESSAGE),
};
